// Global
import React, { JSX } from 'react';
// Local
import { AccordionContextProvider, AccordionItemData } from './AccordionContext';
import { AccordionItem } from './AccordionItem';
import styles from './Accordion.module.scss';

export type AccordionProps = {
  singleOpenPanel?: boolean;
  scrollToOpenPanel?: boolean;
  openByDefault?: boolean;
  accordionItems: AccordionItemData[];
  className?: string;
  itemClassName?: string;
  containerClassName?: string;
  contentClassName?: string;
  ariaLabelledBy?: string | null;
};

export const Accordion = ({
  singleOpenPanel = true,
  scrollToOpenPanel = false,
  openByDefault = false,
  accordionItems,
  className,
  itemClassName,
  containerClassName,
  contentClassName,
  ariaLabelledBy,
}: AccordionProps): JSX.Element => {
  /*
   * Rendering
   */

  const defaultOpenPanels: AccordionItemData[] = [];

  if (openByDefault) {
    if (singleOpenPanel) {
      defaultOpenPanels.push(accordionItems[0]);
    } else {
      defaultOpenPanels.push(...accordionItems);
    }
  }

  return (
    <section
      className={className || styles.base}
      data-component="helpers/accordion"
      aria-labelledby={ariaLabelledBy ?? undefined}
    >
      <AccordionContextProvider
        panels={accordionItems}
        singleOpenPanel={singleOpenPanel}
        scrollToOpenPanel={scrollToOpenPanel}
        defaultOpenPanels={defaultOpenPanels}
        itemClassName={itemClassName}
        contentClassName={contentClassName}
      >
        <div className={containerClassName || styles.container}>
          {accordionItems.map((item) => (
            <AccordionItem key={item.uid} {...item} />
          ))}
        </div>
      </AccordionContextProvider>
    </section>
  );
};
